import { render, staticRenderFns } from "./MappingBagtag.vue?vue&type=template&id=3c20276e"
import script from "./MappingBagtag.js?vue&type=script&lang=js&external"
export * from "./MappingBagtag.js?vue&type=script&lang=js&external"
import style0 from "./MappingBagtag.vue?vue&type=style&index=0&id=3c20276e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports